import React, { useState, useEffect, useCallback } from "react";
import { Modal, Select, Input } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import CustomTextInput from "../CustomTextInput";
import CustomButton from "../CustomButton";
import {
  addUserGroup,
  getUserGroup,
} from "../../redux/actions/groupcampaignAction";
import { getfreeuser } from "../../redux/actions/freeuserAction";

const { Option } = Select;
const { Search } = Input;

const CreateUserGroupModal = ({ visible, onClose, setNotificationmodal }) => {
  const [name, setName] = useState("");
  const [selectedUserId, setSelectedUserId] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [open, setOpen] = useState(false);

  const userdetails = useSelector((state) => state?.Auth?.userDetails?.data);
  const freeuser = useSelector(
    (state) => state?.freeuserReducer?.allsearchfreeuser
  );

  // Fetch users based on search term
  const onSearch = useCallback(
    async (value) => {
      try {
        const payload = {
          organizationid: userdetails.organizationid,
          search: value,
          inmodal: true,
        };
        await getfreeuser(payload);
        setOpen(true);
      } catch (error) {
        console.log("Error searching users:", error);
      }
    },
    [userdetails?.organizationid]
  );

  useEffect(() => {
    if (visible) {
      const fetchAllUsers = async () => {
        try {
          const payload = {
            organizationid: userdetails.organizationid,
            search: "",
            inmodal: true,
          };
          await getfreeuser(payload);
          setOpen(true);
        } catch (error) {
          console.log("Error fetching all users:", error);
        }
      };
      fetchAllUsers();
    } else {
      // Modal is closed: reset all states including dropdown
      setName("");
      setSelectedUserId([]);
      setSearchTerm("");
      setOpen(false); // close the dropdown
    }
  }, [visible, userdetails?.organizationid]);
  
  
  // Handle user selection
  const handleChange = (value) => {
    const selectedUserObjects = freeuser?.freeuser?.filter((user) =>
      value.includes(user._id)
    );
    setSelectedUserId((prev) => {
      const updated = [...prev, ...selectedUserObjects];
      const unique = updated.filter(
        (v, i, a) => i === a.findIndex((t) => t._id === v._id)
      );
      return unique;
    });
  };

  // Remove selected user
  const handleRemoveUser = (userId) => {
    setSelectedUserId((prev) => prev.filter((user) => user._id !== userId));
  };

  // Save handler
  const onSaved = async () => {
    const payload = {
      name,
      users: selectedUserId.map((item) => item._id),
      organizationid: userdetails.organizationid,
    };

    const res = await addUserGroup(payload);
    if (res?.data?.success) {
      setName("");
      setSelectedUserId([]);
      setSearchTerm("");
      await getUserGroup({
        organizationid: userdetails.organizationid,
        page: 1,
      });
      await getfreeuser({ organizationid: userdetails.organizationid });
      onClose();
      if (setNotificationmodal) setNotificationmodal(true);
    }
  };

  // Cancel handler
  const cancel = () => {
    setName("");
    setSelectedUserId([]);
    setSearchTerm("");
    setOpen(false); // Close dropdown manually
    onClose();
  };
  
  

  return (
    <Modal
      className='addusermodal'
      title='Create Group'
      open={visible}
      onCancel={cancel}
      centered
      footer={null}
    >
      <h1>Create User Group</h1>
      <p>Please update details</p>

      <div className='add-user-main'>
        <p>Group Name</p>
        <CustomTextInput className='inputbox' value={name} onChange={setName} />

        <p className='mt-3'>Search Users</p>
        <Search
          placeholder='Search user...'
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onSearch={onSearch}
          enterButton
          className='h-[41px] [&>span>input]:h-[41px] [&_.ant-btn]:h-[41px] [&_.ant-btn]:flex [&_.ant-btn]:items-center'
        />

        <p style={{ paddingTop: "20px", marginLeft: "2px" }}>Add Users</p>
        <Select
  className='dropdown h-[41px]'
  onChange={handleChange}
  mode='multiple'
  placeholder='Select Users'
  style={{ width: "100%" }}
  open={visible && open}
  onBlur={() => setOpen(false)}
  onSearch={onSearch}
  showSearch
  filterOption={false}
  tagRender={() => null}
  // 👇 Force the dropdown to be inside the modal
  getPopupContainer={(triggerNode) => triggerNode.parentNode}
>

          {visible && freeuser?.freeuser
            ?.filter(
              (user) => !selectedUserId.some((sel) => sel._id === user._id)
            )
            .map((user) => (
              <Option key={user._id} value={user._id}>
                {user.name}
              </Option>
            ))}
        </Select>

        { selectedUserId.length > 0 && (
          <div className='removeitem'>
            {selectedUserId.map((item) => (
              <div
                className='removebox'
                key={item._id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "row",
                }}
              >
                <span style={{ color: "#EF4444" }}>{item.name}</span>
                <CloseOutlined
                  onClick={() => handleRemoveUser(item._id)}
                  style={{ marginLeft: "8px", cursor: "pointer" }}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      <div className='btn'>
        <CustomButton
          style={{ marginBottom: "0px" }}
          onClick={onSaved}
          text='Save'
        />
        <CustomButton
          style={{ marginBottom: "0px" }}
          onClick={cancel}
          text='Cancel'
        />
      </div>
    </Modal>
  );
};

export default CreateUserGroupModal;
